const BASE_URL = `/Clientmanagement`

export const createClient = async (client) => {
    try {
        const res = await fetch(`${BASE_URL}/AddClientSetting`, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(client),
        })
        return await res.json()
    } catch (error) {
        console.log(error)
		throw error
    }
}

export const getAllClients = async () => {
    //console.log(token)
    try {
        const res = await fetch(`${BASE_URL}/GetClientsAll`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}
export const getAllClientsWithEventsInDate = async (months) => {
    //console.log(token)
    try {
        const res = await fetch(`${BASE_URL}/GetClientsWithEventsInDate?months=${months}`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getClients = async () => {
    //console.log(token)
    try {
        const res = await fetch(`${BASE_URL}/GetClientsList`, {
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

export const getClientSetting = async (client) => {
//console.log(token)
    try {
        const res = await fetch(`${BASE_URL}/GetClientSettingDTO`, {
            method: 'POST', 
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            credentials: 'include',
            body: JSON.stringify(client),
        })
        return await res.json()
    } catch (error) {
        throw error
    }
}

// commit this page